import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@/styles/common.scss";
import "@/styles/reset.scss";

Vue.use(Vuetify);

export default new Vuetify({});
